;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import React from "react"
import svg from "../../../../common/icons/assets/clinical-peer-group-icon.svg"
import SvgAsset from "./SvgAsset"

function ClinicalPeerGroupIcon({ color }) {
  return (
    <SvgAsset
      svg={svg}
      viewBox="0 0 1200 1200"
      width="55px"
      height="55px"
      color={color ? color : "#AAAAAA"}
    />
  )
}
export default ClinicalPeerGroupIcon
